(function(exports){})(typeof google_myanmar_tools=="undefined"?google_myanmar_tools={}:google_myanmar_tools);